import React, { Component } from 'react';
import { Icon, Form, Button, Table } from 'semantic-ui-react';
import axios from 'axios'
import { serverIp, toCurrency, pythonApiIp } from '../../../../config/constants';
import ResolveCall from './ResolveCall'


function ResolvedCell(props) {
    const theCell = props.call.resolved == 'yes'
        ? <Table.Cell positive>{props.call.resolved}</Table.Cell>
        : <Table.Cell negative><Button>Solve</Button></Table.Cell>

    return (
        <div>
            {theCell}
        </div>
    )
}


class CallRecordsList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            callRecords: [],
        }
    }

    componentDidMount() {
        console.log("cpx1 ======componentDidMount");
        this.getCallRecords();
    }



    resolveCall = () => {
        console.log("cpx1 ======resolveCall");

        this.setState({ loading: true })

        axios.post(pythonApiIp + 'resolveCallRecord', {
            apiKey: "asdfasdf",
            enteredBy: this.props.user.email
        })
            .then((response) => {
                this.setState({ loading: false })
                console.log(response.data);

                if (response.data.result) {
                    console.log("true.. setting coupon");

                    this.setState({ callRecords: response.data.callRecords });

                } else {
                    console.log("FAILED");
                    alert("FAILED TO get callRecords:" + response.data.message);
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loading: false
                })
            });
    }

    getCallRecords = () => {
        console.log("cpx1 ======getCallRecords");

        this.setState({ loading: true })

        axios.post(pythonApiIp + 'getCallRecords', {
            apiKey: "asdfasdf",
            enteredBy: this.props.user.email
        })
            .then((response) => {
                this.setState({ loading: false })
                console.log(response.data);

                if (response.data.result) {
                    console.log("true.. setting coupon");

                    this.setState({ callRecords: response.data.callRecords });

                } else {
                    console.log("FAILED");
                    alert("FAILED TO get callRecords:" + response.data.message);
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loading: false
                })
            });
    }

    render() {


        const tableRow = this.state.callRecords.length > 0
            ? this.state.callRecords.map((call) =>
                <Table.Row>
                    <Table.Cell> {call.idcallrecords} </Table.Cell>
                    <Table.Cell> {call.customernumber} </Table.Cell>
                    <Table.Cell> {call.callreason} </Table.Cell>
                    <Table.Cell> {call.notes} </Table.Cell>
                    <Table.Cell> {call.dateentered} </Table.Cell>
                    <ResolveCall call={call} getCallRecords={this.getCallRecords} user={this.props.user}/>
                    {/* <Table.Cell> {call.resolveddate} </Table.Cell> */}
                    {/* <ResolveTextOrNotes call={call} /> */}
                </Table.Row>)
            : ''

        return (<div>
            <Table celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>id</Table.HeaderCell>
                        <Table.HeaderCell>customernumber</Table.HeaderCell>
                        <Table.HeaderCell>callreason</Table.HeaderCell>
                        <Table.HeaderCell>notes</Table.HeaderCell>
                        <Table.HeaderCell>dateentered</Table.HeaderCell>
                        <Table.HeaderCell>resolved</Table.HeaderCell>
                        {/* <Table.HeaderCell>resolveddate</Table.HeaderCell> */}
                        {/* <Table.HeaderCell>resolvednotes</Table.HeaderCell> */}
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {tableRow}
                </Table.Body>

            </Table>
        </div>);
    }
}

export default CallRecordsList;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/CallRecords/CallRecordsList.js